import { type TgWebInitData } from '@/shared/api/user/types';

// InitData comes from the web in an atypical format, we need to save fotmat to get a token
export function parseInitDataForWeb(initData: string): TgWebInitData {
  const rawParams = new URLSearchParams(initData);
  const result: Partial<TgWebInitData> = {};

  for (const [key, value] of rawParams.entries()) {
    if (key === 'user') {
      try {
        const user = JSON.parse(value);
        Object.assign(result, user);
      } catch {
        console.warn('Failed to parse user JSON:', value);
      }
    } else {
      (result as any)[key] = value;
    }
  }

  return result as TgWebInitData;
}
